import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateCommissionConfigMutationVariables = Types.Exact<{
  input: Types.CreateCommissionConfigInput;
}>;


export type CreateCommissionConfigMutation = { __typename?: 'Mutation', createCommissionConfig: { __typename?: 'CommissionConfigPayload', commissionConfig?: { __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCommissionDefaultRateMutationVariables = Types.Exact<{
  input: Types.SetCommissionDefaultRateInput;
}>;


export type SetCommissionDefaultRateMutation = { __typename?: 'Mutation', setCommissionDefaultRate: { __typename?: 'CommissionConfigPayload', commissionConfig?: { __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerCommissionOverrideMutationVariables = Types.Exact<{
  input: Types.SetCustomerCommissionOverrideInput;
}>;


export type SetCustomerCommissionOverrideMutation = { __typename?: 'Mutation', setCustomerCommissionOverride: { __typename?: 'CommissionConfigPayload', commissionConfig?: { __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearCustomerCommissionOverrideMutationVariables = Types.Exact<{
  input: Types.ClearCustomerCommissionOverrideInput;
}>;


export type ClearCustomerCommissionOverrideMutation = { __typename?: 'Mutation', clearCustomerCommissionOverride: { __typename?: 'CommissionConfigPayload', commissionConfig?: { __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateCommissionConfigDocument = new TypedDocumentString(`
    mutation CreateCommissionConfig($input: CreateCommissionConfigInput!) {
  createCommissionConfig(input: $input) {
    commissionConfig {
      ...CommissionConfig
    }
    errors {
      code
      message
    }
  }
}
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}`);
export const SetCommissionDefaultRateDocument = new TypedDocumentString(`
    mutation SetCommissionDefaultRate($input: SetCommissionDefaultRateInput!) {
  setCommissionDefaultRate(input: $input) {
    commissionConfig {
      ...CommissionConfig
    }
    errors {
      code
      message
    }
  }
}
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}`);
export const SetCustomerCommissionOverrideDocument = new TypedDocumentString(`
    mutation SetCustomerCommissionOverride($input: SetCustomerCommissionOverrideInput!) {
  setCustomerCommissionOverride(input: $input) {
    commissionConfig {
      ...CommissionConfig
    }
    errors {
      code
      message
    }
  }
}
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}`);
export const ClearCustomerCommissionOverrideDocument = new TypedDocumentString(`
    mutation ClearCustomerCommissionOverride($input: ClearCustomerCommissionOverrideInput!) {
  clearCustomerCommissionOverride(input: $input) {
    commissionConfig {
      ...CommissionConfig
    }
    errors {
      code
      message
    }
  }
}
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateCommissionConfig: build.mutation<CreateCommissionConfigMutation, CreateCommissionConfigMutationVariables>({
      query: (variables) => ({ document: CreateCommissionConfigDocument, variables })
    }),
    SetCommissionDefaultRate: build.mutation<SetCommissionDefaultRateMutation, SetCommissionDefaultRateMutationVariables>({
      query: (variables) => ({ document: SetCommissionDefaultRateDocument, variables })
    }),
    SetCustomerCommissionOverride: build.mutation<SetCustomerCommissionOverrideMutation, SetCustomerCommissionOverrideMutationVariables>({
      query: (variables) => ({ document: SetCustomerCommissionOverrideDocument, variables })
    }),
    ClearCustomerCommissionOverride: build.mutation<ClearCustomerCommissionOverrideMutation, ClearCustomerCommissionOverrideMutationVariables>({
      query: (variables) => ({ document: ClearCustomerCommissionOverrideDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateCommissionConfigMutation, useSetCommissionDefaultRateMutation, useSetCustomerCommissionOverrideMutation, useClearCustomerCommissionOverrideMutation } = injectedRtkApi;
